export enum DocumentCategory {
  Identification = 'identification',
  Citizenship = 'citizenship',
  Residency = 'residency',
  HighSchoolDeclaration = 'highSchoolDeclaration',
  BiologicalAndAdoptiveParentsDeclaration = 'biologicalAndAdoptiveParentsDeclaration',
}